import PicturesApp from 'station/components/picture/PicturesApp'
import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import useTitle from 'utils/customHook/useTitle'
import i18n from 'simple-react-i18n'
import { getStationTitle } from 'utils/StationUtils'

const PluviometryPicturesApp = ({

}) => {
    const {
        pluviometer,
        pluviometers,
    } = useSelector(store => ({
        pluviometer: store.PluviometryReducer.pluviometer,
        pluviometers: store.PluviometryReducer.pluviometers,
    }), shallowEqual)

    useTitle(() => [{
        title: i18n.pluviometry,
        href: 'pluviometry',
    }, {
        title: getStationTitle(pluviometer),
        href: `station/pluviometry/${pluviometer?.id}`,
    }, {
        title: i18n.picturesAndDocuments,
        href: `station/pluviometry/${pluviometer?.id}/picture`,
    }], [pluviometer])

    return (
        <PicturesApp
            stations={pluviometers}
            station={pluviometer}
            stationType='pluviometry'
        />
    )
}

export default PluviometryPicturesApp